import type { StaticEntityType } from "@config";
import { Group } from "@library-containers/layers";
import { getComboName, getComboSettings } from "@library/shared";
import { SetView } from "./Set.view";

export const SetLibrary = ({ entity }: { entity: StaticEntityType }) => {
  const { children, settings, id, layers } = entity;
  const comboName = getComboName(layers);
  const comboSettings = getComboSettings(layers);
  const isNarrator = comboName === "Narrator";
  if (!children) return null;
  return (
    <SetView
      entity={{
        ...entity,
        settings: { ...settings, comboName, combo: comboSettings },
      }}
    >
      {(isNarrator ? [children[0]] : children).map((child, index) => (
        <Group
          key={child.id}
          entity={{
            ...child,
            layers: { ...(entity.layers || {}), set: { settings, id, index } },
          }}
        />
      ))}
    </SetView>
  );
};
